module.exports = __webpack_public_path__ + "img/flip_to_front.585d67c9.svg";